import React from 'react';
import { HiBriefcase } from 'react-icons/hi';
import { getUserPreferenceUIConfig } from 'shared-utils';
import { HiringAssessmentListCard, TechStackType } from 'types';

interface Props {
	position: HiringAssessmentListCard;
}

const HiringAssessmentPositionCardDetail = ({ position }: Props) => {
	return (
		<>
			<div className="flex md:mb-2 sm:gap-x-4 mt-1 sm:gap-y-[6px] flex-col  md:gap-[6px]">
				<div className="flex flex-row gap-2 items-center">
					<div>
						<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2]" />
					</div>
					<div className="flex gap-1 items-center sm:text-[12px] text-[14px] text-[#28293D] dark:text-[#E4E4EB]">
						<div>
							{getUserPreferenceUIConfig({ text: position?.userPreferenceSnapshot?.experienceLevel || '' })?.finalText}
						</div>
						{!position?.userPreferenceSnapshot?.techStack?.includes(TechStackType.OTHER) ? (
							<>
								<span className="text-[#28293D] font-inter text-[12px] font-medium leading-[16px]">|</span>
								<div className="flex gap-[4px]">
									<img src="/assets/recruiterImages/tag.svg" alt="Tag" className="max-w-4 w-full" />
									<span className="text-[#28293D] font-inter text-[12px] font-medium leading-[16px]">
										{getUserPreferenceUIConfig({ text: position?.userPreferenceSnapshot?.techStack || '' })?.finalText}
									</span>
								</div>
							</>
						) : null}
						<div className="font-inter font-[500] text-[18px] leading-[16px] text-[#28293D] dark:text-[#C7C9D9]">•</div>
						{position.salaryRange.min ?? 0} - {position.salaryRange.max ?? 0} LPA
					</div>
				</div>

				{/* <div className="flex flex-row gap-2 items-center">
					<div>
						<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2]" />
					</div>
					<div className="flex items-center sm:text-[12px] text-[14px] text-[#28293D] dark:text-[#E4E4EB]">
						{position.salaryRange.min ?? 0} - {position.salaryRange.max ?? 0} LPA
					</div>
				</div> */}
			</div>
		</>
	);
};

export default HiringAssessmentPositionCardDetail;
